module.exports = __webpack_public_path__ + "img/ic_notification_gift.fd367f8a.svg";